import {createStrokeSVG} from './TEMPLATE'

// tabler: clock
export const Clock_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: ['M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0', 'M12 7v5l3 3'],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
